import React, { useState, useEffect } from 'react';
import { Card, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import api from '../../api';

const Vacancies = () => {
    const [jobs, setJobs] = useState([]);

    useEffect(() => {
        (async () => {
            const res = await api.get('/jobs');
            setJobs(res.data.data.jobs);
        })()
    }, [])

    return (
        <section className="section-vacancies">
            <Container>
                {/* <h1>Vacancies ({jobs.length})</h1> */}
                <h1 className="d-flex align-items-center">
                    <span>
                        Vacancies
                    </span>
                    <span style={{ fontSize: '22px', marginLeft: '5px', color: '#a6a6a6' }}>
                        Total no. of positions ({jobs.reduce((ac, cr) => ac + cr.locations.reduce((acc, cur) => acc + cur.numberOfVacancies, 0), 0)})
                    </span>
                </h1>

                <div className="mt-4">
                    {/* [{ id: 1 }] */}
                    {jobs.map(vac => (
                        <Link className="vacancy-link" to={`/vacancies/${vac.id}`}>
                            <Card key={vac.id} className="vacancy-card">
                                <div>
                                    <h4 className="d-flex align-items-center">
                                        <span>
                                            {vac.title}
                                        </span>
                                        <span style={{ fontSize: '16px', marginLeft: '5px', color: '#a6a6a6' }}>
                                            Total no. of positions ({vac.locations.reduce((acc, cur) => acc + cur.numberOfVacancies, 0)})
                                        </span>
                                    </h4>
                                    {vac.locations.map((loc, index) => (
                                        <p
                                            style={{ display: 'inline-block', margin: '5px 5px 0px 0px', }}
                                        >
                                            {`${loc.location} (${loc.numberOfVacancies})${(vac.locations.length - 1 === index) ? '' : ','}`}
                                        </p>
                                    ))}
                                </div>
                                <div>
                                    <i class="fas fa-arrow-right"></i>
                                </div>
                            </Card>
                        </Link>
                    ))}
                </div>
            </Container>
        </section>
    )
};

export default Vacancies;